//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { logOT } from '@shared/loggingShared'
import { CompanyProfileCTO } from '@shared/CompanyProfileCTO'
import { User } from 'oidc-client-ts'
import { EthAddr } from '@shared/SchemaTypes'

export enum TemplateFormat {
  USDC = 'USDC',
  DateTime = 'DateTime',
  EthAddr = 'EthAddr',
}

export const companyProfilePut = async (
  serverApiBaseUrl: string,
  companyProfile: Partial<CompanyProfileCTO>,
  restAPIKey: string,
  cognitoUser?: User
): Promise<CompanyProfileCTO> => {
  if (!companyProfile.uuid) {
    companyProfile.uuid = uuidv4()
  }

  const accessToken = cognitoUser?.access_token
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
      Authorization: `Bearer ${accessToken}`,
    },
  }
  const r = await axios.put(`${serverApiBaseUrl}/companyProfiles/${companyProfile.uuid}`, companyProfile, config)
  const data = r.data
  logOT.debug('companyProfilePut', data)
  return data.results
}
export const companyProfileForAccountPut = async (
  serverApiBaseUrl: string,
  companyProfile: Partial<CompanyProfileCTO>,
  restAPIKey: string,
  signedMessage: string,
  accountAddr: EthAddr
): Promise<CompanyProfileCTO> => {
  if (!companyProfile.uuid) {
    companyProfile.uuid = uuidv4()
  }

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  }
  const r = await axios.put(
    `${serverApiBaseUrl}/companyProfileForAccount/${accountAddr}`,
    { companyProfile, signedMessage },
    config
  )
  const data = r.data
  logOT.debug('companyProfileForAccountPut', data)
  return data.results
}
export const companyProfileGet = async (serverApiBaseUrl: string, uuid: string): Promise<CompanyProfileCTO> => {
  try {
    const r = await axios.get(`${serverApiBaseUrl}/companyProfiles/${uuid}`)
    const data = r.data
    logOT.debug('companyProfileGet', data)
    return data.results
  } catch (e) {
    logOT.error('companyProfileGet', e)
    return {
      uuid,
      companyName: 'Unregistered',
      wallets: [],
      emails: [],
    }
  }
}

export const companyProfilesGet = async (serverApiBaseUrl: string): Promise<CompanyProfileCTO[]> => {
  const r = await axios.get(`${serverApiBaseUrl}/companyProfiles`)
  const data = r.data
  const profiles = data.results
  return profiles
}
